// JOBE-0167.1: useCedarCapabilities — operator-permission lookup.
//
// v1 reads from a module-level capability map. The map is populated by
// the operator-permissions context once that wiring lands (the same
// plumbing JOBE-0148.1/.2's Capabilities/Access tabs will use). Until
// then, the v1 default grants memory:read only — write capabilities
// (correct/explain/forget) default to denied so the inspect-view
// action footer (JOBE-0167.4) renders no buttons unless an operator
// has been explicitly granted them.
//
// Test pattern: vi.mock('./useCedarCapabilities.js', () => ({
//   useCedarCapabilities: () => ({ 'memory:read': { permitted: true }, … })
// })).

const DEFAULT_CAPS = {
  'memory:read':    { permitted: true },
  'memory:correct': { permitted: false },
  'memory:explain': { permitted: false },
  'memory:forget':  { permitted: false },
};

let overrideCaps = null;

/** Test helper: install a capability map at module scope. */
export function __setCedarCapabilitiesForTest(caps) {
  overrideCaps = caps;
}

/** Test helper: clear any installed override. */
export function __resetCedarCapabilitiesForTest() {
  overrideCaps = null;
}

export function useCedarCapabilities() {
  if (overrideCaps) return overrideCaps;
  return DEFAULT_CAPS;
}
